import { SerpIntermediaryReplaceSnapshot } from '@/components/Approval/@components/SerpIntermediaryReplace';
import { parseSerpContent } from '@/utils/approval/serpDocument';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 182 SERP 중간관리자 교체 정산 — 저장 content 그대로(레거시 조회와 동일) */
const SerpIntermediaryReplaceSlot = ({ data }: ContentExtraProps) => {
  const content = parseSerpContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SerpIntermediaryReplaceSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SerpIntermediaryReplaceSlot;
